module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_3_6_1.0aed7b43.jpeg";